export const LOG_IN = 'log_in';

export const GET_COUNTS = 'get_counts';

export const GET_TOPICS = 'get_topics';
export const GET_TOPIC = 'get_topic';
export const UPDATE_TOPIC = 'update_topic';
export const GET_ALL_TOPIC_WEIGHTS = 'get_all_topic_weights';

export const GET_FEEDS = 'get_feeds';
export const GET_FEED = 'get_feed';
export const GET_FEED_FIXTURES = 'get_feed_fixtures';
export const GET_FEED_ARTICLES = 'get_feed_articles';
export const GET_FEED_VIDEOS = 'get_feed_videos';
export const GET_FEED_LOGS = 'get_feed_logs';
export const REIMPORT_FEED_CONTENT = 'reimport_feed_content';
export const FLUSH_FEED_FIXTURES = 'flush_feed_fixtures';
export const CREATE_FEED = 'create_feed';
export const UPDATE_FEED = 'update_feed';

export const GET_FIXTURE = 'get_fixture';
export const UPDATE_FIXTURE = 'update_fixture';
export const UPDATE_FIXTURE_LEADERBOARD = 'update_fixture_leaderboard';
export const REIMPORT_FIXTURE = 'reimport_fixture';

export const GET_ARTICLES = 'get_articles';
export const GET_ARTICLE = 'get_article';
export const UPDATE_ARTICLE = 'update_article';
export const TOGGLE_ARTICLE = 'toggle_article';
export const REIMPORT_ARTICLE = 'reimport_article';

export const GET_VIDEOS = 'get_videos';
export const GET_VIDEO = 'get_video';
export const UPDATE_VIDEO = 'update_video';
export const TOGGLE_VIDEO = 'toggle_video';
export const REIMPORT_VIDEO = 'reimport_video';

export const CACHE_CLEAR_ARTICLE = 'cache_clear_article';
export const CACHE_CLEAR_TAGS = 'cache_clear_tags';

export const GET_EXPLORER_DATA = 'get_explorer_data';

export const GET_HISTORY_DATA = 'get_history_data';

export const UPDATE_POSITIONS = 'update_positions';

export const GET_PAGES = 'get_pages';
export const GET_PAGE = 'get_page';
export const CREATE_PAGE = 'create_page';
export const UPDATE_PAGE = 'update_page';

export const GET_WEIGHTS = 'get_weights';
export const UPDATE_WEIGHT = 'update_weight';

export const UPDATE_ROUND_NAMES = 'update_round_names';